import {get} from "lodash"

export default function getCodeFromError(err: any): string {
  // if there is a config property, it was probably an axios request
  const fallback = err?.config ? "Network Error" : ""

  return (
    attemptToGetCode(err) || fallback // we have no idea
  )
}

/**
 * @description: low level functionality to find a potential error code,
 * you should probably use `getCodeFromError()` instead
 */
export function attemptToGetCode(err: any): string | undefined {
  return (
    err?.extensions?.errorCode || // graph response (spec-compliant)
    err?.code || // simple assign
    err?.errorCode || // graph response (legacy top-level)
    get(err, "response.data.code") || // REST API response
    // Adding back the following lines to attempt to get error code from apollo client errors, which have a different format. This is needed for the logout on error logic to work correctly.
    get(err, "data.errors[0].extensions.errorCode") || // apollo client raw error (spec-compliant)
    get(err, "data.errors[0].errorCode") || //  apollo client raw error (legacy)
    get(err, "data.response.errors[0].extensions.errorCode") || // apollo client error (spec-compliant)
    get(err, "data.response.errors[0].errorCode") || // apollo client error (legacy)
    get(err, "networkError.response.data.errors[0].extensions.errorCode") || // (spec-compliant)
    get(err, "networkError.response.data.errors[0].errorCode") ||
    get(err, "networkError.errorCode") || // our marshalled GraphError (see getGraphError) - errors are surfaced as a networkError
    get(err, "networkError.response") || // low level apollo error
    get(err, "graphQLErrors[0].extensions.errorCode") || // mid level apollo error (spec-compliant)
    get(err, "graphQLErrors[0].errorCode") || // mid level apollo error (legacy)
    undefined
  )
}
